export default __webpack_public_path__ + "static/media/clientes.03ed4ce3.jpg";